// /az/careers/$sphere — sphere page (AZ). Unknown slug → 404.
import { createFileRoute, notFound } from "@tanstack/react-router";
import { SpherePage } from "@/careers/SpherePage";
import { careersHead, BASE_URL } from "@/careers/head";
import { sphereJsonLd } from "@/careers/careerPages";
import { UI, SPHERE_SLUGS, sphereDescription } from "@/careers/spheres";
import { buildSphere } from "@/careers/data";

export const Route = createFileRoute("/az/careers/$sphere")({
  loader: ({ params }) => {
    if (!SPHERE_SLUGS.includes(params.sphere)) throw notFound();
  },
  head: ({ params }) => {
    const slug = params.sphere;
    const data = buildSphere(slug, "az");
    if (!data) return {};
    const alt = {
      az: `/az/careers/${slug}`,
      ru: `/careers/${slug}`,
      en: `/en/careers/${slug}`,
    };
    const title = `${data.name} · ${UI.az.breadcrumbRoot} — Yolutap`;
    const description = sphereDescription("az", data.name, data.count, data.subtitle);
    const jsonLd = sphereJsonLd({
      sphereName: data.name,
      baseUrl: BASE_URL,
      rootPath: `/az/careers`,
      spherePath: `/az/careers/${slug}`,
      breadcrumbRoot: UI.az.breadcrumbRoot,
    });
    return careersHead({ lang: "az", canonicalPath: `/az/careers/${slug}`, altPaths: alt, title, description, jsonLd });
  },
  component: () => {
    const { sphere } = Route.useParams();
    return <SpherePage lang="az" slug={sphere} />;
  },
});
